document.addEventListener("DOMContentLoaded", () => {
    // ソート
    const url_sort = "sort_by=";
    const sort_box = document.getElementById("sort_by");
    sort_box.addEventListener("change", function(event) {
        const sortValue = event.target.value;
        const url = url_sort + sortValue;
        location.search = url;
    });
    // ソート
    const loca_search = location.search;
    const rep_text_sort = loca_search.replace("?sort_by=", "");
    document
        .querySelectorAll(`.kusaba_colection-navi__select-input[value*=${rep_text_sort}]`)
        .forEach(x => {
            x.checked = true;
        });
    // フィルター
    const url_filter = "&";
    const filter_box = document.getElementById("filter_by");
    filter_box.addEventListener("change", function(event) {
        const sortValue = event.target.value;
        const url = url_filter + sortValue;
        location.search = url;
    });
    // フィルター
    const rep_text_filter = loca_search.replace("?=", "").replace("&=", "");
    document
        .querySelectorAll(`.kusaba_colection-navi__select-input[value*=${rep_text_filter}]`)
        .forEach(x => {
            x.checked = true;
        });
    const tagsElement = document.querySelector("#tags");
    tagsElement.addEventListener("change", function(event) {
        if (event.target.value) {
            window.location.href = "/collections/all/" + event.target.value;
        } else {
            window.location.href = "/collections/all/";
        }
    });
});

document.addEventListener("DOMContentLoaded", () => {
    // 商品詳細バリエーション変更時トップへ移動
    const sort_box = document.getElementById("SingleOptionSelector-0");
    sort_box.addEventListener("change", function(event) {
        scrollTo(0, 0);
    });
});
